export const OMR_BADGE_IMAGE_SRC =
    'https://fiverr-res.cloudinary.com/image/upload/f_png,q_auto/v1/attachments/generic_asset/asset/3d8050fb7481dadbfed390a786cc55bb-1772023860419/OMR-badge.svg';
